import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AzureFileUploadControl } from 'src/app/_controls/image-uploader';
import { Enums } from 'src/app/_models/generatedEnums';
import { CertificationBodyViewModel, UserCertificationViewModel } from 'src/app/_models/generatedModels';
import { CEUService, StaticDataService, UserService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-add-user-certification-modal',
  templateUrl: 'add-user-certification-modal.component.html',
})
export class AddUserCertificationModalComponent implements OnInit {
  initialized = false;
  @ViewChild('myForm') myForm: FormGroupDirective;
  submitComplete: Promise<{}> | undefined;

  errorMessage: string;
  bodies: CertificationBodyViewModel[];
  @Input() certification: UserCertificationViewModel;
  @Input() lockTocertificationBodyId?: number;

  constructor(private activeModal: NgbActiveModal, private toaster: ToasterService, private userService: UserService, private ceuService: CEUService, private staticData: StaticDataService) {}

  ngOnInit(): void {
    this.ceuService.getCertificationBodies().subscribe((result) => {
      this.bodies = result;
      if (!this.certification) {
        this.certification = new UserCertificationViewModel();
        this.certification.certificationBodyId = this.lockTocertificationBodyId;
      } else {
      }
      this.initialized = true;
    });
  }

  compare(a: any, b: any) {
    console.log('here');
    console.log(a);
    console.log(b);
    return a === b;
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  onSave() {
    this.errorMessage = '';
    if (!this.myForm.valid) {
      this.myForm.form.markAllControlsDirty();
      return;
    }

    if (this.certification.id) {
      this.submitComplete = new Promise((resetButton: any, reject) => {
        this.userService.updateCertification(this.certification.id, this.certification).subscribe(
          (result) => {
            this.toaster.success('Certification Updated');
            this.activeModal.close();
            resetButton();
          },
          (error) => {
            this.errorMessage = error.error[0];
            resetButton();
          }
        );
      });
    } else {
      this.submitComplete = new Promise((resetButton: any, reject) => {
        this.userService.createCertification(this.certification).subscribe(
          (result) => {
            this.toaster.success('Certification Added');
            this.activeModal.close();
            resetButton();
          },
          (error) => {
            this.errorMessage = error.error[0];
            resetButton();
          }
        );
      });
    }
  }
}
